import "./ReservationPage.css";
import { useState, useEffect } from "react";

const Day = (props) => {
  const i = props.i;
  let [changeOnClick, setChangeOnClick] = useState("black");
  let [controlClick, setControlClick] = useState(false);

  let clickFun = () => {
    if (props.allowedClick === true) {
      setControlClick(true);
      if (typeof props.cb === "function") {
        props.cb(i);
      }
    }
  };
  useEffect(() => {
    if (controlClick) {
      setChangeOnClick("blue");
    }
  }, [changeOnClick, controlClick]);

  const dayStyle = {
    border: "1px solid white",
    color: props.color,
    backgroundColor: controlClick && props.bgColor,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0px",
    padding: "0px",
  };

  return (
    <div
      style={dayStyle}
      className={props.color === "white" ? "daysNum" : ""}
      onClick={clickFun}
    >
      {props.children}
    </div>
  );
};

export default Day;
